import Link from 'next/link';

import Button from '~components/Button';
import Pencil from '~components/Icon/Pencil';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import useCompanyReviewWorkLife from '~hooks/query/company/useCompanyReviewWorkLife';
import useGetMyInfoQuery from '~hooks/query/user/useMyInfoQuery';
import { useRouterQuery } from '~hooks/useRouterQuery';
import theme from '~lib/styles/Theme';

import * as S from '../style';
import ChartContents from './ChartContents';
import NudgeLoginSection from './NudgeLoginSection';

interface Props {
  isDisplay?: boolean;
}
export default function WorkLifeSection({ isDisplay }: Props) {
  const { isActiveUser, data } = useGetMyInfoQuery();
  const companyHash = useRouterQuery('companyId');
  const { data: companyInfo } = useGetCompanyInfo(companyHash);
  const { isEmpty, isLoading } = useCompanyReviewWorkLife(companyHash);

  return (
    <S.SectionWrapper>
      <S.SectionHeader>
        <S.SectionTitle>
          <img src='/images/ico-emoji-balance-scale@2x.png' alt='emoji' />
          <span>워라밸</span>
        </S.SectionTitle>
        {data?.workLifeReview && (
          <S.RightCardHeaderWrapper>
            {!isLoading && isEmpty && (
              <S.Tooltip animStart={isDisplay}>
                기업의 첫 리뷰를 <S.BreakLineOnlyMobile />
                작성해주세요!
              </S.Tooltip>
            )}
            <Link
              href={`/review/work-life-balance?companyHash=${companyHash}&beforeUrl=/company/${companyHash}#company-review-chart`}>
              <Button
                data-attribute-id='company__review__write__click'
                data-is-review-exist={isEmpty ? 'false' : 'true'}
                data-is-blur='false'
                data-company-hash={companyInfo?.PK_NM_HASH}
                data-company-name={companyInfo?.name}
                data-review-type={'work-life-balance'}
                variant={!isLoading && isEmpty ? 'magenta' : 'light'}
                size='sm'
                as='a'
                leading={
                  <S.ButtonWriteWrapper>
                    <Pencil
                      color={!isLoading && isEmpty ? theme.colors.white100 : theme.colors.gray800}
                      width={12}
                      height={12}
                    />
                  </S.ButtonWriteWrapper>
                }>
                리뷰 작성
              </Button>
            </Link>
          </S.RightCardHeaderWrapper>
        )}
      </S.SectionHeader>
      <S.SectionContents>
        {isActiveUser && data?.workLifeReview ? (
          <ChartContents />
        ) : (
          <NudgeLoginSection isActiveUser={isActiveUser} />
        )}
      </S.SectionContents>
    </S.SectionWrapper>
  );
}
